import { ResponseStateEnum } from "../discovery-process.enum";

export enum ChatUserType {
    User,
    Consultant
}
export interface ChatConsultant  {
    id: string;
    name: string;
    title: string;
    photoURL: string;
    type: ChatUserType;

}

export interface ChatUser  {
    id: string;
    name: string;
    title: string;
    photoURL: string;
    type: ChatUserType;
}

export interface PossibleResponse {
    id: string;
    idx: number;
    dependency: string;
    questionId: string;
    motivationId: string;
    motivationScore: number;
    responseText: string;
    selected?: boolean;
}

export interface DiscoveryChatQuestion {
    id: string;
    idx: number;
    isAnswered?: boolean;
    selectedResponseId?: string;
    sentTimestamp?: string;
    batchId: string;
    batchIdx: number;
    setId: string;
    setIdx: number;
    userResponsesNo: number;
    type: number;
    questionText: string;
    questionWizardText: string;
    possibleResponses: PossibleResponse[];

}

export interface ChatRollMessage {
    id: string;
    text: string;
    participant: ChatConsultant | ChatUser;
    timestamp: string;
}

export interface DiscoveryResponse {
    questionId : string;
    responseId: string;
    responseType?: ResponseStateEnum;
}

export interface ContinueJourneyResponse {
    journeyId: unknown;
    totalQuestions: number;
}

export enum BatchId{
    Gap = "B99",
    Tail = "B100",
    System = "SYS"
}